<template>
  <div class="trading-container">
    <div class="trading-row">
      <div v-for="(item, ti) in objects" :key="'t' + ti">
        <div v-if="item.row==1" @click="doShowPopup(ti)" :class="'trading-goods ' + item.icon"></div>
      </div>
    </div>
    <div class="trading-row middle-row">
      <div v-for="(item, mi) in objects" :key="'m' + mi">
        <div v-if="item.row==2" @click="doShowPopup(mi)" :class="'trading-goods ' + item.icon"></div>
      </div>
    </div>
    <div class="trading-row">
      <div v-for="(item, bi) in objects" :key="'b' + bi">
        <div v-if="item.row==3" @click="doShowPopup(bi)" :class="'trading-goods ' + item.icon"></div>
      </div>
    </div>
    <h2 class="trading-text">Goods traded by the VOC</h2>
  </div>
</template>

<script>
export default {
  name: "TradingGoods",
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    showPopup() {
      return this.$store.getters.getShowPopup
    },
    objects() {
      return this.$store.getters.getObjects
    }
  },
  methods: {
    doShowPopup(index) {
      this.$store.commit("setSelectedIndex", index)
      this.$store.commit("setShowPopup", !this.showPopup)
    }
  }
};
</script>

<style scoped>
.trading-container {
  background-color: var(--light-blue);
  border: 0.75em solid var(--light-blue);
  border-radius: 0.25em;
}

.trading-goods {
  width: clamp(2em, 5.5vw, 2.75em);
  height: clamp(2em, 5.5vw, 2.75em);
  background-size: contain;
  margin: 0;
  transition: 0.1s;
}
.trading-goods:hover {
  transform: scale(1.25);
  filter: brightness(115%)
          drop-shadow(0 0 0.25em var(--indigo));
}
.trading-row {
  pointer-events: auto;
  display: flex;
  justify-content: center;
}
.middle-row {
  margin: -0.25em 0.25em;
}
.trading-text {
  height: 0;
  margin: 0;
  transform: translateY(1em);
}
@media (max-width: 800px) {
  h2 {
    opacity: 0;
    transition: 0.25s;
  }
}
</style>